import React, { useEffect, useState } from 'react'
import { client, urlFor } from './sanityClient'
import { useNavigate } from 'react-router-dom'


export default function FeaturedBlogs() {
  const [posts, setPosts] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    const fetchPosts = async () => {
      const query = `
        *[_type == "post"] | order(publishedAt desc)[0...4]{
          title,
          slug,
          publishedAt,
          "categories": categories[]->{
            title,
            slug
          },
          body,
          mainImage
        }
      `
      const data = await client.fetch(query)
      setPosts(data)
    }
    fetchPosts()
  }, [])

  // Helper to truncate words
  const truncateWords = (text, wordLimit = 20) => {
    if (!text) return ''
    const words = text.split(/\s+/)
    return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : text
  }

  return (
    <section id="insights" style={{ padding: '4rem 2rem', background: '#f9f9f9' }}>
      < h2 className="text-4xl md:text-5xl font-bold text-[#101527] mb-12">Legal Insights</h2>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '2rem'
      }}>
        {posts.map(post => (
          <div
            key={post.slug.current}
            style={{
              background: '#fff',
              borderRadius: '12px',
              boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s'
            }}
            onClick={() => navigate(`/blog/${post.slug.current}`)} // go to individual post
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-5px)'
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.1)'
            }}
          >
            {/* Post Image */}
            {post.mainImage && (
              <img
                src={urlFor(post.mainImage).width(600).height(300).url()}
                alt={post.title}
                style={{ width: '100%', height: '200px', objectFit: 'cover' }}
              />
            )}

            <div style={{ padding: '1rem 1.5rem' }}>
              <h2>{post.title}</h2>
              <p style={{ fontSize: '0.85rem', color: '#555', marginBottom: '0.5rem' }}>
                Categories: {post.categories?.map(c => c.title).join(', ')}
              </p>

              {/* Short excerpt */}
              <p style={{ fontSize: '0.9rem', color: '#333' }}>
                {truncateWords(post.body ? post.body.map(block => block.children.map(c => c.text).join(' ')).join(' ') : '', 25)}
              </p>

              {/* Read More button */}
              <button
                onClick={(e) => {
                  e.stopPropagation() // prevent double navigation
                  navigate(`/blog/${post.slug.current}`)
                }}
                style={{
                  marginTop: '1rem',
                  padding: '0.5rem 1rem',
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: '#101527',
                  color: '#fff',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                Read More
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Button to full blog page */}
      <div style={{ textAlign: 'center', marginTop: '3rem' }}>
        <button
          onClick={() => navigate('/insights')}
          style={{
            padding: '0.75rem 2rem',
            borderRadius: '8px',
            border: 'none',
            backgroundColor: '#101527',
            color: '#fff',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          View All Blogs
        </button>
      </div>
    </section>
  )
}
